import { useAppContext } from '@/context/AppContext';
import { GroupList } from './GroupList';
import { StatisticsDashboard } from './StatisticsDashboard';

export function Content() {
  const { state } = useAppContext();

  if (!state.xmlDoc) {
    return (
      <div className="content-empty">
        <p>Load an XML file to begin editing groups.</p>
      </div>
    );
  }

  return (
    <div className="content">
      <StatisticsDashboard />
      <GroupList 
        groupType={state.ui.selectedGroupType}
        xmlDoc={state.xmlDoc}
        vehicleData={state.vehicleData}
      />
    </div>
  );
}